export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://languageintelligence-backend.bartoszbudzynski.pl';
export const PRESENTATIONS_API_BASE_URL = 'https://api.speaker-toolkit.com';